import { Component, Injector, OnInit, ViewChild, ChangeDetectorRef, ElementRef } from '@angular/core';

import { BaseFormComponent } from '../base-form.component';
import { AmorphicService } from '../../../../services/amorphic/amorphic.service';
import { CoverpathControllerInterface } from '../../../../interfaces/controller/CoverpathControllerInterface';
import { BasicTextInputComponent } from '../basic-text-input/basic-text-input.component';
import { CheckboxBasicComponent } from '../basic-checkbox/basic-checkbox.component';
import { SelectBasicComponent } from '../select-basic/select-basic.component';
import { TextDateLongComponent } from '../text-date-long/text-date-long.component';

@Component({
  moduleId: module.id,
  selector: 'optional-input',
  templateUrl: './optional-input.component.html',
})
export class OptionalInputComponent extends BaseFormComponent implements OnInit {
  optionalInput: BasicTextInputComponent | SelectBasicComponent | TextDateLongComponent;
  @ViewChild('optionalInput') set optionalInputSetter(
    element: BasicTextInputComponent | SelectBasicComponent | TextDateLongComponent
  ) {
    this.optionalInput = element;
  }

  @ViewChild('optionalInputCheckbox', { static: true }) optionalInputCheckbox: CheckboxBasicComponent;
  controller: CoverpathControllerInterface;
  controlType: string;
  inputIsDisabled: boolean = false;
  property: string;
  propertyPath: string;
  altProperty: string;
  altPropertyPath: string;
  altPropertyType: string;

  constructor(protected injector: Injector, private amorphicService: AmorphicService) {
    super(injector);
    this.controller = this.amorphicService.controller;
    this.questionItem = this.injector.get('questionItem');
  }

  ngOnInit() {
    super.ngOnInit();
    this.setComponentProperties();
  }
  private setComponentProperties(): void {
    // Get the relevant entity object from the metadata node
    const entity: object = this.getEntityBaseReference(this.questionItem);
    // Use this.prop instead of this.questionItem.prop,
    // because this.prop have [i] replaced with loopIndex, this.questionItem.prop does not
    this.propertyPath = this.prop;
    this.property = this.propertyPath.split('.').pop(); // The optional (input) property
    this.altProperty = this.questionItem.optionalInputProperty; // The alternate (checkbox) property
    this.altPropertyPath = this.prop.substring(0, this.prop.lastIndexOf('.')) + '.' + this.altProperty;
    this.altPropertyType = this.questionItem.optionalInputPropertyType;
    this.controlType = this.questionItem.optionalInputControlType;

    // Sets the proper boolean value whether the alternate property type is boolean or string
    this.inputIsDisabled = this.optionalInputCheckbox.inputText =
      this.altPropertyType === 'string' ? entity[this.altProperty] === 'true' : entity[this.altProperty];
  }

  triggerCheckbox(): void {
    // Note: inputText in CheckboxBasicComponent is a boolean that represents the checkbox status
    const checkboxIsEnabled: boolean = this.optionalInputCheckbox.inputText;

    if (checkboxIsEnabled) {
      this.clearInput(this.optionalInput);
      this.setValuesOnController(true);
    } else {
      this.clearInput(this.optionalInputCheckbox);
      this.setValuesOnController(false);
    }

    this.inputIsDisabled = checkboxIsEnabled;
    this.updateProgressAndSubscriptions();
  }

  private setValuesOnController(inputIsOptional: boolean): void {
    // Get the relevant entity object from the metadata node
    const entity: object = this.getEntityBaseReference(this.questionItem);

    // Sets the proper value whether the alternate property is of type boolean or string
    entity[this.property] = inputIsOptional ? null : entity[this.property];
    entity[this.altProperty] = this.altPropertyType === 'string' ? inputIsOptional.toString() : inputIsOptional;
  }

  clearInput(inputComponent): void {
    inputComponent.resetValue();
  }
  resetValue() {}
  updateFromModel(): void {}
}
